module.exports = __webpack_public_path__ + "img/img_delivery_quick_possible.04805f5.png";